import { render, staticRenderFns } from "./IdentityPersonal.vue?vue&type=template&id=ffbdb96a"
import script from "./IdentityPersonal.vue?vue&type=script&lang=js"
export * from "./IdentityPersonal.vue?vue&type=script&lang=js"
import style0 from "./IdentityPersonal.vue?vue&type=style&index=0&id=ffbdb96a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports